import classNames from 'classnames'
import { useRouter } from 'next/router'
import React, { ChangeEvent, useRef } from 'react'
import { uploadQiNiu } from '~/apis/upload-oss'
import { useValidateAuth } from '~/hooks/useValidateAuth'
import { OssBucket } from '~/graphqls/types'
import { getFileSize } from '~/utils'
import { message } from 'antd'

interface Props {
  multiple?: boolean
  disabled?: boolean
  /** 文件大小限制，单位 M */
  limit?: number
  dirname?: string
  children?: React.ReactNode
  accept?: string
  needLogin?: boolean
  className?: string
  setFileList: React.Dispatch<React.SetStateAction<any[]>>
  maxCount?: number
}

const FileUpload = ({
  multiple = true,
  limit = 50,
  dirname,
  children,
  accept,
  needLogin = false,
  className,
  setFileList,
  disabled,
  maxCount = Infinity,
}: Props) => {
  const { validateIsLogin } = useValidateAuth()
  const router = useRouter()
  const idCountRef = useRef(0)
  const handleUpload = async (file: File) => {
    const commonProps = {
      fileSize: getFileSize(file.size),
      fileName: file.name,
      filtType: file.type.startsWith('image/') ? 'image' : 'file',
      status: 'pending',
      url: undefined,
    }
    setFileList(prev => {
      if (prev.length >= maxCount) {
        return prev
      }
      return [...prev, commonProps]
    })
    // return {
    //   ...commonProps,
    //   url: 'https://cdn.wujiebantu.com/ai/87E2726EE40DF4CA622EF942A15603C80260D28E2C3F53F7DA71FD2FB433E1AB_svg_file_a827dc8b-8f59-45bc-bb46-3ceae1358954.svg',
    // }
    // 上传七牛
    const { url } = await uploadQiNiu(
      file,
      undefined,
      OssBucket.TRADE_PROTECT,
      dirname
    )

    commonProps.status = 'completed'
    // @ts-ignore
    commonProps.url = url
    setFileList(prev => [...prev])
  }

  const beforeUplaod = (file: File) => {
    if (needLogin) {
      if (!validateIsLogin()) {
        return null
      }
    }
    if (file.size > 1024 * 1024 * limit) {
      message.destroy()
      message.error(`请上传 ${limit}M 内的文件`)
      return null
    }
    return file
  }

  const onFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    e.persist()
    const { files: rawFiles } = e.target
    if (!rawFiles) return
    let files = [].slice.call(rawFiles) as File[]
    e.target.value = '' // HACK: fix the same file doesn't trigger onChange

    // beforeUpload 处理file对象
    const postFiles = files.map(file => {
      return beforeUplaod(file)
    })

    await Promise.all(postFiles).then(filesList => {
      files = filesList.filter(Boolean) as File[]
    })

    if (files.length === 0) {
      return
    }
    const newTasks = files.map(file => ({
      id: idCountRef.current++,
      status: 'pending',
      file,
    }))

    // 执行任务
    await Promise.all(
      newTasks.map(async currentTask => {
        try {
          // 上传文件
          const result = await handleUpload(currentTask.file)
          console.log('result', result)
        } catch (e) {
          console.log(e)
        }
      })
    ).catch(error => console.error(error))
  }

  return (
    <div className={classNames('relative overflow-hidden', className)}>
      {children}
      {/* 用 label 隐藏 input 提示: “未选择任何文件” */}
      <label
        htmlFor="gpt-4o-uploadimage"
        className={classNames(
          'absolute top-0 left-0 right-0 bottom-0  opacity-0 z-10 text-[0px]',
          disabled ? 'cursor-default' : 'cursor-pointer'
        )}
      ></label>
      <input
        id="gpt-4o-uploadimage"
        className="hidden"
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={onFileChange}
        aria-hidden
        disabled={disabled}
      />
    </div>
  )
}

export default FileUpload
